<template lang="html">
<div>
  <v-dialog v-if="logged" v-model="exibirMensagem" transition="false" persistent width="350">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        <v-layout justify-center>{{ this.tituloMensagem }}</v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout justify-center>{{ this.textoMensagem }}</v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-layout align-center justify-center>
          <v-btn color="primary" text @click="clicouCiente()">Ciente</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="globalLoading" transition="false" persistent width="350">
    <v-card>
      <v-container fill-height>
        <v-layout>
          <v-flex>
            <div align="center">
              <v-progress-circular indeterminate :size="70" :width="5" class="blue--text"></v-progress-circular>
            </div>
            <h3 class="headline mb-0" align="center">Por favor, aguarde.</h3>
            <h3 v-for="item in globalLoadingMessageArray" align="center">{{item}}</h3>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    dialog: true
  }),
  computed: {
    ...mapGetters('ui', ['globalLoadingMessageArray', 'globalLoadingTitle', 'globalLoading', 'exibirMensagem', 'tituloMensagem', 'textoMensagem']),
    ...mapGetters('auth', ['logged'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_MENSAGEM', 'HIDE_MENSAGEM']),
    clicouCiente () {
      this.HIDE_MENSAGEM()
    }
  }
}
</script>

<style lang="css" scoped>
  div.card {
    border: 5px solid black;
  }
</style>



// WEBPACK FOOTER //
// loading.vue?960bf124